import { Modal } from "./Modal/Modal";
import {
  bitcoin,
  lightning,
  paymentModeInfo,
  selectPaymentMode,
} from "./messages";
import Text from "./text/Text";
import { bitCoinSymbol, fill } from "./images";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { Box } from "@mui/system";

function PaymentModeModal({ handleModalClose, openModal, setSelectedMode }) {
  const modeArr = [
    {
      name: bitcoin,
      img: bitCoinSymbol,
    },
    {
      name: lightning,
      img: fill,
    },
  ];
  const renderModalContent = () => {
    return (
      <Box>
        <Text
          className="grey-text"
          font="regular"
          size={16}
          sx={{ marginBottom: "10px" }}
        >
          {paymentModeInfo}
        </Text>
        {modeArr.map((mode) => {
          return (
            <Box
              className="mode-box"
              onClick={(e) => {
                setSelectedMode(mode?.name?.toLowerCase());
              }}
            >
              <Box display="flex" alignItems="center">
                <img src={mode.img} alt="bitcoin" className="mode-img" />
                <Text className="default-text" font="semibold" size={16}>
                  {mode.name}
                </Text>
              </Box>
              <Box display="flex" alignItems="center">
                <KeyboardArrowDownOutlinedIcon
                  sx={{
                    marginLeft: "14px",
                    color: "#848B9E",
                    transform: "rotate(270deg)",
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Box>
    );
  };
  return (
    <Modal
      maxWidth="xs"
      className="selection-mode-modal"
      open={openModal}
      body={renderModalContent()}
      handleClose={handleModalClose}
      title={selectPaymentMode}
      closeIcon
    />
  );
}

export default PaymentModeModal;
